"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

exports.getCoordinates = getCoordinates;
exports.legitCoordinates = legitCoordinates;
exports.getCoordinatesForAddress = getCoordinatesForAddress;

var _PostalAreaCoordinates = require("../helpers/PostalAreaCoordinates");

var _PostalAreaCoordinates2 = _interopRequireDefault(_PostalAreaCoordinates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCoordinates(location) {
  var name = location.toLowerCase();
  var delimiter = void 0;

  if (name.includes("/")) {
    delimiter = "/";
  }

  if (name.includes("ja")) {
    delimiter = "ja";
  }

  if (delimiter) {
    var partLocation = name.split(delimiter).map(function (part) {
      return part.trim().toLowerCase();
    }).map(function (part) {
      return _PostalAreaCoordinates2.default[part];
    }).filter(function (coordinates) {
      return !!coordinates;
    });
    if (partLocation.length) {
      return partLocation[0];
    }
  }

  var nullLocation = { lat: 0, lng: 0 };
  return _PostalAreaCoordinates2.default[name] || nullLocation;
}

function legitCoordinates(lat, lng) {
  return !!(lat && lng && lat !== 0 && lng !== 0);
}

function getCoordinatesForAddress(address, postalArea) {
  var searchAddress = void 0;

  if (!postalArea && !address) {
    return;
  } else if (!postalArea) {
    searchAddress = address;
  } else if (!address) {
    searchAddress = postalArea;
  } else {
    searchAddress = address + ", " + postalArea;
  }

  return new _promise2.default(function (resolve, reject) {
    if (!google) {
      reject("No Google Maps defined.");
    }
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ "address": searchAddress, "region": "fi" }, function (results, status) {
      if (status === "OK") {
        resolve(results[0].geometry.location);
      } else {
        reject(status);
      }
    });
  });
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/LocationsUtil.js
 ** module id = 210
 ** module chunks = 0
 **/